export default function Footer() {
  const scrollTo = (id: string) => {
    const el = document.getElementById(id);
    if (el) el.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <footer id="footer" className="w-full bg-foreground-900 text-background-50">
      <div className="w-full px-4 md:px-6 py-10 md:py-12">
        <div className="w-full max-w-7xl mx-auto">
          {/* Top: Logo + Links */}
          <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-8">
            {/* Brand */}
            <div className="flex flex-col gap-3">
              <div className="flex items-center gap-2">
                <span className="w-8 h-8 flex items-center justify-center bg-primary-500 rounded-lg">
                  <i className="ri-fire-fill text-background-50 text-lg"></i>
                </span>
                <span className="font-heading text-lg font-bold">
                  今日大瓜
                </span>
              </div>
              <p className="text-sm text-background-50/60 leading-relaxed">
                聚焦娱乐热点与热点大瓜追踪，实时更新娱乐圈热点爆料。
                热点吃瓜资讯一网打尽，让你不错过任何热门事件。
              </p>
            </div>

            {/* Quick Links */}
            <div className="flex flex-col gap-2">
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-1">快速导航</h4>
              {[
                { id: 'features', label: '吃瓜利器' },
                { id: 'ranking', label: '大瓜热榜' },
                { id: 'updates', label: '实时快讯' },
                { id: 'faq', label: '吃瓜答疑' },
              ].map((item) => (
                <a
                  key={item.id}
                  href={`#${item.id}`}
                  onClick={(e) => { e.preventDefault(); scrollTo(item.id); }}
                  className="text-sm text-background-50/60 hover:text-primary-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {item.label}
                </a>
              ))}
            </div>

            {/* Categories */}
            <div className="flex flex-col gap-2">
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-1">热门分类</h4>
              {['明星八卦', '影视追踪', '音乐动态', '综艺热点'].map((item) => (
                <a
                  key={item}
                  href="#index"
                  onClick={(e) => { e.preventDefault(); scrollTo('index'); }}
                  className="text-sm text-background-50/60 hover:text-accent-400 transition-colors duration-200 whitespace-nowrap"
                >
                  {item}
                </a>
              ))}
            </div>

            {/* Partners */}
            <div className="flex flex-col gap-2">
              <h4 className="font-heading text-sm font-semibold text-background-50 mb-1">合作伙伴</h4>
              <p className="text-sm text-background-50/40 leading-relaxed">
                欢迎优质媒体与内容平台合作，共创娱乐资讯新生态。
              </p>
            </div>
          </div>

          {/* Bottom bar */}
          <div className="mt-8 pt-6 border-t border-background-50/10 flex flex-col sm:flex-row items-center justify-between gap-3">
            <p className="text-xs text-background-50/40">
              &copy; 2024-2026 今日大瓜 jindagua.com 版权所有
            </p>
            <div className="flex items-center gap-4">
              <span className="text-xs text-background-50/40 whitespace-nowrap">隐私政策</span>
              <span className="text-xs text-background-50/40 whitespace-nowrap">用户协议</span>
              <span className="text-xs text-background-50/40 whitespace-nowrap">免责声明</span>
            </div>
          </div>
        </div>
      </div>
    </footer>
  );
}